// import axios from 'axios'
import { post, put, get } from "@/api/api";

export const actions = {
  fetchTickets({ commit }) {
    // const { pageNumber = 0, pageSize = state.pagination.size } = params
    return get(`/canal/ticket`).then(({ data }) => {
      commit("addTickets", data);
    });
  },
  async fetchTicketsPage({commit}, params = {}) {
    const { page = 0, size = 10, sort = '', libelle = '', user = '', numero = '', statut = '', date = '', preShowStartTime = '', afterHoraire = '', beforeHoraire = '', film = '', idSalle = '', screen = '', montant = '', after = '', before = ''  } = params;
    const queryParams = new URLSearchParams({
      page,
      size,
      sort,
      ...(libelle && { libelle }),
      ...(user && { user }),
      ...(numero && { numero }),
      ...(statut && { statut }),
      ...(date && { date }),
      ...(preShowStartTime && { preShowStartTime }),
      ...(afterHoraire && { afterHoraire }),
      ...(beforeHoraire && { beforeHoraire }),
      ...(film && { film }),
      ...(idSalle && { idSalle }),
      ...(screen && { screen }),
      ...(montant && { montant }),
      ...(after && { after }),
      ...(before && { before }),
    }).toString();

    let { data } = await get(`/canal/ticket/page?${queryParams}`);
    commit("addTicketsPage", data)
    return data;
  },
  createTicket({ commit }, ticket) {
    return post("/canal/ticket", ticket).then(({ data }) => {
      commit("addTicket", data);
    });
  },
  updateTicket({ commit }, ticket) {
    return put(`/canal/ticket${ticket.id}`, ticket).then(({ data }) => {
      commit("replaceTicket", data);
    });
  },
  createOrUpdateTicket({ dispatch }, ticket) {
    if (ticket.id !== undefined) {
      return dispatch("updateTicket", ticket);
    } else {
      return dispatch("createTicket", ticket);
    }
  },
  selectTicket({ commit }, ticket) {
    commit("setTicket", ticket);
  },
  async downloadFile(params = {}) {
    try {
      const queryParams = new URLSearchParams(params).toString();
      const { data } = await get(`/canal/ticket/exportToExcel?${queryParams}`, {
        responseType: 'blob' 
      });

      const blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      const url = URL.createObjectURL(blob);

      const link = document.createElement('a');
      link.href = url;
      link.download = `resultats_recherche.xlsx`; 
      document.body.appendChild(link);

      link.click(); 
      document.body.removeChild(link); 

      URL.revokeObjectURL(url); 
    } catch (error) {
      console.error("Erreur lors du téléchargement :", error);
    }
  }
};
